import { render, staticRenderFns } from "./TermoDeUso.vue?vue&type=template&id=2736b501&"
import script from "./TermoDeUso.vue?vue&type=script&lang=js&"
export * from "./TermoDeUso.vue?vue&type=script&lang=js&"
import style0 from "./TermoDeUso.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports